import axios from 'lib/axios'

interface Test360CreateProcessResponse {
  success: boolean
  message: string
  data?: any
}

const test360CreateProcess = async (processId: number): Promise<Test360CreateProcessResponse> => {
  const apiUrl = `/process/test_360`

  try {
    const response = await axios.post(apiUrl, { process_id: processId })
    return response.data
  } catch (error: any) {
    console.error('error creating test 360 process', error)
    return {
      success: false,
      message: error?.response?.data?.message || 'Error al crear el proceso Test 360',
      data: error?.response?.data
    }
  }
}

export default test360CreateProcess
